module.exports = __webpack_public_path__ + "static/media/profile.34294cc3.png";